import { render, staticRenderFns } from "./QuickClassicProduct.vue?vue&type=template&id=3c18d3a4&"
import script from "./QuickClassicProduct.vue?vue&type=script&lang=js&"
export * from "./QuickClassicProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports